import React from 'react';
import './App.css';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import Products from './components/pages/Products';
import BookingCalendar from './components/pages/BookingCalendar';
import AddTalent from './components/pages/AddTalent';
import CompanyList from './components/pages/CompanyList';
import AddCompany from './components/pages/AddCompany';
import LanoCreateATask from './components/pages/LanoCreateATask';
import AppNavbar from './components/AppNavbar'
import ProtectedRoute from './helpers/ProtectedRoute'; 
import NoPrivilages from './components/pages/NoPrivilages';
import NewBookingCreationPage from './components/pages/ClientService/NewBookingCreationPage';
import ProposeTalentsBookingDetail from './components/SetCastUser/ProposeTalentsBookingDetail';
import NewBookingsPage from './components/SetCastUser/NewBookingsPage';
import MyBookingsPage from'./components/pages/Talent/MyBookingsPage'
import LoginForm from './LoginForm';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import UserDataForm from './components/pages/UserDataForm';
import NewUserRegistration from './components/pages/NewUserRegistration';
import SetVacationPage from './components/pages/Talent/SetVacationPage';
import TalentInvitations from './components/pages/Talent/TalentInvitations';
import ProposedBookingsPage from './components/pages/ClientService/ProposedBookingsPage';
import EditBooking from './components/SetCastUser/EditBooking';
import Profile from './components/pages/Profile';
import ExcelUploadButton from './helpers/ExcelUploadButton';
import AllBookingsPage from './components/pages/AllBookingsPage';
import ConfirmedBooking from './components/SetCastUser/ConfirmedBooking';
import TalentListPlaniing from './components/pages/ClientService/TalentListPlaniing';
import AllFutureBookingGroups from './components/pages/AllFutureBookingGroups';
import BookingDetailsPage from './components/SetCastUser/BookingDetailsPage';
import TalentOrdersList from './components/pages/Talent/TalentOrdersList';
import TalentsOnHold from './components/SetCastUser/TalentsOnHold';
import CreateDummyOrders from './components/SetCastUser/CreateDummyOrder';
import CreateKindOrder from './components/SetCastUser/CreateKindOrder';
import RequestedBookings from './components/SetCastUser/RequestedBookings';
import TalentListCalendar from './components/pages/talentListCalendar';
import DeletedOrdersPage from './components/SetCastUser/DeletedOrdersPage';
import LanoIds from './components/pages/LanoIds';
import TalentOverview from './components/pages/ClientService/TalentOverview';
import HomePage from './components/pages/Talent/HomePage';
import NewAllBookings from './components/SetCastUser/NewAllBookings';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import CalendarPageWithData from './components/pages/CalendarPage';
import LoginTest from './components/LoginTest';
import TalentListApi from './components/pages/Talent/TalentListApi';
import TalentEditApi from './components/pages/Talent/TalentEditApi';
import TalentListSimple from './components/pages/Talent/TalentListSimple';
import TalentEditSimple from './components/pages/Talent/TalentEditSimple';
import AgencyManagement from './components/pages/Talent/AgencyManagement';
import TalentCalendarPage from './components/pages/Talent/TalentCalendarPage';
import TalentCreditNotesList from './components/pages/Talent/TalentCreditNotesList';
import CompanyGroupManagement from './components/pages/Admin/CompanyGroupManagement';
import TalentRelationshipView from './components/pages/TalentRelationshipView';
import OldTalentList from './components/pages/ClientService/OldTalentList';
import LocationManagement from './components/pages/LocationManagement';
import TalentGroupManagement from './components/pages/TalentGroupManagement';
import ConfirmedListCreditNotes from './components/pages/CreditNotes/ConfirmedListCreditNotes';
import CreditNotesList from './components/pages/CreditNotes/CreditNotesList';
import CreditNotesCancelled from './components/pages/CreditNotes/CreditNotesCancelled';
import StatsPage from './components/pages/StatsPage';
import Footer from './components/Footer';

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

function AppRoutes() {
  const { currentUser, userRole } = useAuth();

  // Special route for login test page
  if (window.location.pathname === '/login-test') {
    return <LoginTest />;
  }

  // If user is not authenticated, show login or password reset pages
  if (!currentUser) {
    return (
      <Routes>
        <Route path="/" element={<LoginForm />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/login-test" element={<LoginTest />} />
        <Route path="*" element={<LoginForm />} />
      </Routes>
    );
  }

  // User is authenticated, show the app with proper navigation
  return (
    <>
      <AppNavbar />
      <Routes>
        <Route path="/login-test" element={<LoginTest />} />
        <Route path="/np/*" element={<ProtectedRoute allowedRoles={[null]} />}>
          <Route index element={<NoPrivilages />} />
        </Route>

        <Route path="/admin/*" element={<ProtectedRoute allowedRoles={['superadmin']} />}>
          <Route path='propose' element={<ProposeTalentsBookingDetail />} />
          <Route path='company-group' element={<CompanyGroupManagement />} />
          <Route path='locations' element={<LocationManagement />} />
          <Route path='newallbookings' element={<NewAllBookings />} />
          <Route path='upload' element={<ExcelUploadButton />} />
          <Route index element={<NewBookingsPage />} />
          <Route path='neworders' element={<NewBookingsPage />} />
          <Route path="addtalent" element={<AddTalent />} />
          <Route path="add-company" element={<AddCompany />} />
          <Route path='company-list' element={<CompanyList />} />
          <Route path="lanotaskcreate" element={<LanoCreateATask />} />
          <Route path='products' element={<Products />} />
          <Route path='lanoids' element={<LanoIds />} />
          <Route path='edit' element={<EditBooking />} />
          <Route path='user-data' element={<UserDataForm />} />
          <Route path='users' element={<UserDataForm />} />
          <Route path='talent-groups' element={<TalentGroupManagement />} />
          <Route path='new-user-registration' element={<NewUserRegistration />} />
          <Route path='talent-relationships' element={<TalentRelationshipView />} />
          <Route path='profile' element={<Profile />} />
      
          <Route path='allbooking' element={<NewAllBookings />} />
          <Route path='talent-list' element={<TalentListApi />} />
          <Route path='talent-list-api' element={<TalentListApi />} />
          <Route path='talent-list-simple' element={<TalentListSimple />} />
          <Route path='talent-list-simple/edit/:id' element={<TalentEditSimple />} />
          <Route path='agency-management' element={<AgencyManagement />} />
          <Route path='talent/edit/:id' element={<TalentEditApi />} />
          <Route path='confirmed' element={<ConfirmedBooking />} />
          <Route path='pending-credit-notes' element={<ConfirmedListCreditNotes />} />
          {/* Old path — keep redirecting so existing bookmarks and links don't 404. */}
          <Route path='confirmed-credit-notes' element={<Navigate to='/admin/pending-credit-notes' replace />} />
          <Route path='credit-notes' element={<CreditNotesList />} />
          <Route path='credit-notes-canceled' element={<CreditNotesCancelled />} />
          <Route path='allgroups' element={<AllFutureBookingGroups />} />
          <Route path='detail' element={<BookingDetailsPage />} />
          <Route path='new'element={<NewBookingCreationPage />} />
          <Route path='talents-hold'element={<TalentsOnHold />} />
          <Route path='create-dummy'element={<CreateDummyOrders />} />
          <Route path='create-kind-order'element={<CreateKindOrder />} />
          <Route path='requested'element={<RequestedBookings />} />
          <Route path='tlistcal'element={<TalentListCalendar />} />
          <Route path='deleted'element={<DeletedOrdersPage />} />
          <Route path='calendar'element={<CalendarPageWithData />} />
          <Route path='stats' element={<StatsPage />} />
        </Route>

        <Route path="/user/*" element={<ProtectedRoute allowedRoles={['editor', 'superadmin']} />}>
          <Route path="addtalent" element={<AddTalent />} />
          <Route path="lanotaskcreate" element={<LanoCreateATask />} />
          <Route index element={<BookingCalendar />} />
          <Route path="add-company" element={<AddCompany />} />
          <Route path='company-list' element={<CompanyList />} />
          <Route path='talent-list' element={<TalentListApi />} />
          <Route path='profile' element={<Profile />} />
          <Route path='calendar'element={<CalendarPageWithData />} />
        </Route>

        <Route path="/talent/*" element={<ProtectedRoute allowedRoles={['talent', 'superadmin']} />}>
          <Route index element={<HomePage />} />
          <Route path='home' element={<HomePage />} />
          <Route path='my-bookings-page' element={<MyBookingsPage />} />
          <Route path='vacation' element={<SetVacationPage />} />
          <Route path='invitations' element={<TalentInvitations />} />
          <Route path='profile' element={<Profile />} />
          <Route path='orders' element={<TalentOrdersList />} />
          <Route path='credit-notes' element={<TalentCreditNotesList />} />
          <Route path='calendar'element={<CalendarPageWithData />} />
          <Route path='my-calendar'element={<TalentCalendarPage />} />
          <Route path='agency-management' element={<AgencyManagement />} />
        </Route>

        <Route path="/finance/*" element={<ProtectedRoute allowedRoles={['finance']} />}>
          <Route index element={<ConfirmedListCreditNotes />} />
          <Route path='pending-credit-notes' element={<ConfirmedListCreditNotes />} />
          {/* Old path — keep redirecting so existing bookmarks and links don't 404. */}
          <Route path='confirmed-credit-notes' element={<Navigate to='/finance/pending-credit-notes' replace />} />
          <Route path='credit-notes' element={<CreditNotesList />} />
          <Route path='agency-management' element={<AgencyManagement />} />
          <Route path='talent-list-simple' element={<TalentListSimple />} />
          <Route path='talent-list-simple/edit/:id' element={<TalentEditSimple />} />
          <Route path='profile' element={<Profile />} />
        </Route>

        <Route path="/cs/*" element={<ProtectedRoute allowedRoles={['clientService', 'superadmin', 'planning']} />}>
          <Route index element={<AllBookingsPage />} />
          <Route path='company-group' element={<CompanyGroupManagement />} />
          <Route path='locations' element={<LocationManagement />} />
          <Route path='old-talent-list' element={<OldTalentList />} />
          <Route path='new'element={<NewBookingCreationPage />} />
          <Route path='create-kind-order' element={<CreateKindOrder />} />
          <Route path='talent-list' element={<TalentListApi />} />
          <Route path='allbooking' element={<AllBookingsPage />} />
          <Route path="add-company" element={<AddCompany />} />
          <Route path='company-list' element={<CompanyList />} />
          <Route path='proposed' element={<ProposedBookingsPage />} />
          <Route path='profile' element={<Profile />} />
          <Route path='rate-talent' element={<TalentListPlaniing />} />
          <Route path='allgroups' element={<AllFutureBookingGroups />} />
          <Route path='upload' element={<ExcelUploadButton />} />
          <Route path='tlistcal'element={<TalentListCalendar />} />
          <Route path='talentoverview'element={<TalentOverview />} />
          <Route path='talent-relationships' element={<TalentRelationshipView />} />
          <Route path='edit' element={<EditBooking />} />
          <Route path='calendar'element={<CalendarPageWithData />} />
        </Route>
      </Routes>
      <Footer/>
    </>
  );
}

export default App;
